/* eslint-disable react/prop-types */
import React from 'react';
import { QueryBuilderContext } from '../QueryBuilderContext/QueryBuilderContext.js';
import { QB_DRAG_TYPES } from '../helpers/types.js';
import AndOrController from '../AndOrController/AndOrController.js';
import QueryBuilderRow from '../QueryBuilderRow/QueryBuilderRow.js';

const QueryBuilderItem = ({ item }) => {
  const { element } = item;
  const { type, idFilter, idGroup, condition } = element;
  return (
    <QueryBuilderContext.Consumer>
      {({
        fields,
        handleFieldChange,
        onAddFilter,
        onAddFilterToGroup,
        onAddRuleContainer,
        onRemoveFilter,
        showDragController,
        handleRuleContainerOperator,
        handleRuleContainerUnGroup,
        step,
        items,
        isDraggableItem,
        setDraggableItems,
        singleRow,
        toolTipZIndex,
      }) => {
        if (type === QB_DRAG_TYPES.FILTER) {
          return (
            <QueryBuilderRow
              {...element}
              fields={fields}
              handleFieldChange={handleFieldChange}
              isDraggableItem={isDraggableItem}
              items={items}
              onAddFilter={() => onAddFilter(idGroup, idFilter)}
              onAddRuleContainer={() => onAddRuleContainer(idGroup, idFilter)}
              onRemoveFilter={() => onRemoveFilter(idFilter)}
              setDraggableItems={setDraggableItems}
              showDragController={showDragController}
              step={step}
              singleRow={singleRow}
              toolTipZIndex={toolTipZIndex}
            />
          );
        }
        if (singleRow) return null;
        return (
          <AndOrController
            allowUnGroup
            condition={condition}
            handleRuleContainerOperator={(value) => handleRuleContainerOperator(idGroup, value)}
            handleRuleContainerUnGroup={() => handleRuleContainerUnGroup(idGroup)}
            multipleSize={false}
            onAddFilter={() => onAddFilterToGroup(idGroup)}
            showDragController
            step={step}
            toolTipZIndex={toolTipZIndex}
          />
        );
      }}
    </QueryBuilderContext.Consumer>
  );
};

export default QueryBuilderItem;
